import { AuthenticatedLayout } from "@components/layouts/AuthenticatedLayout";
import { ToBeSignedDocumentsView } from "@containers/toBeSignedDocuments/ToBeSignedDocumentsView";

const ToBeSignedSessionsPage = () => {
    return (
        <AuthenticatedLayout activeMenuItem="tobeSignedDocuments">
            <ToBeSignedDocumentsView />
        </AuthenticatedLayout>
    );
}

export default ToBeSignedSessionsPage;